import React from "react";
import { useI18n } from "@/i18n/I18nProvider";
import { useSEO } from "@/hooks/useSEO";
import { Btn } from "@/components/ui-kit/Kit";
import { MaskLines } from "@/components/motion/Reveal";
import { GpuMark } from "@/components/brand/GpuLogo";

export default function NotFound() {
  const { t } = useI18n();
  useSEO({ title: "Page not found", description: "The page you requested could not be found.", path: "/404", noindex: true });

  return (
    <section className="relative flex min-h-[70vh] items-center overflow-hidden bg-navy-deep text-white grain" data-testid="not-found-page">
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 hairline-grid" />
      <div className="relative container py-24">
        <GpuMark className="h-20 w-20" size="md" onDark />
        <p className="mt-10 font-mono text-[11px] uppercase tracking-[0.3em] text-gold">Error 404</p>
        <h1 className="mt-6 max-w-[20ch] font-display text-[clamp(2.2rem,6vw,4.6rem)] font-bold leading-[1.02]">
          <MaskLines lines={["This page could not", "be located."]} />
        </h1>
        <p className="mt-8 max-w-xl text-sm text-white/60">
          The page may have been moved, renamed or is not yet published by the GPU secretariat.
        </p>
        <Btn to="/" variant="solid" className="mt-10" data-testid="notfound-home">
          {t("cta.back")}
        </Btn>
      </div>
    </section>
  );
}
